var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c72a388af5bdcceb82c87c58c03e7554a009cf1f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-app@groove"]={id:"c72a388af5bdcceb82c87c58c03e7554a009cf1f"};
      